import { render, staticRenderFns } from "./ModalDistributors.vue?vue&type=template&id=2bff09a0&scoped=true&"
import script from "./ModalDistributors.vue?vue&type=script&lang=js&"
export * from "./ModalDistributors.vue?vue&type=script&lang=js&"
import style0 from "./ModalDistributors.vue?vue&type=style&index=0&id=2bff09a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff09a0",
  null
  
)

export default component.exports